import React from 'react'
import {Box, Grid, Stack} from '@mui/material'
import {apiConstants, postGeneric} from '../../common/constants'
import {FormProvider} from '../../common/hook-form'
import {useForm} from 'react-hook-form'
import {useSnackbar} from 'notistack'

import {yupResolver} from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import axios from 'axios'
import {useDispatch} from 'react-redux'
import {decodeAuthToken} from '../../helpers/UtilityHelper'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {fetchReportData} from '../../redux/actions/reportAction'
import {login, loginUserDataSlice} from '../../redux/userSlice'
import {
  DividerText,
  ForgotPasswordButton,
  HeaderContainer,
  IconContainer,
  StyledDivider,
  StyledIcon,
  StyledLoadingButton,
  StyledTextField,
  SubTitle,
  WelcomeTitle,
} from './StyledElements'
import {Password, VerifiedUser} from '@mui/icons-material'

export default function MobileLogin() {
  const [isLoading, setIsLoading] = React.useState(false)
  const {enqueueSnackbar} = useSnackbar()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const otpSchema = Yup.object().shape({
    otp: Yup.string()
      .matches(/^[0-9]{6}$/, 'OTP must be exactly 6 digits')
      .required('OTP is required'),
  })

  const methods = useForm({
    resolver: yupResolver(otpSchema),
    defaultValues: {
      otp: '',
    },
  })
  const {handleSubmit} = methods
  const location = useLocation()
  const mobileNumber = location.state?.mobileNumber
  const mfaTokenId = location.state?.mfaTokenId

  const onSubmit = async (data) => {
    setIsLoading(true)
    try {
      const payload = {
        mobileNumber: mobileNumber,
        otp: data.otp,
        panel: 'MERCHANT',
        tokenId: mfaTokenId,
      }
      const res = await postGeneric(apiConstants.VALIDATE_OTP, payload)
      if (res.status === 200) {
        try {
          const {data: dataLogin} = res
          // store user's token in local storage
          localStorage.setItem('userToken', dataLogin.accessToken)
          if (dataLogin.refreshToken) localStorage.setItem('refreshToken', dataLogin.refreshToken)
          dispatch(loginUserDataSlice({...dataLogin}))
          const {merchantOid, merchantList, roles, switchableMerchantOids} = decodeAuthToken(dataLogin.accessToken)
          const hasSwitchableMerchants = Array.isArray(switchableMerchantOids) && switchableMerchantOids.length > 0

          // if users are assigned navigate to select user page
          if (
            hasSwitchableMerchants ||
            (roles?.includes('ROLE_PROSHIPADMIN') &&
            (merchantList === undefined || merchantList?.length === 0 || merchantList?.length > 0))
          ) {
            let url = '/loginuser'
            navigate(url)
          } else {
            let merchantData
            let config = {
              headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('userToken'),
              },
            }
            let merchantUrl = apiConstants.BASE_LOCAL + apiConstants.GET_MERCHANT_SEARCH
            const {data} = await axios.post(
              merchantUrl,
              {
                offset: 0,
                limit: 1,
                orfilter: [],
                andfilter: [{field: 'id', operator: 'eq', value: merchantOid}],
                excludes: 'mappedOrderRule,sla',
              },
              config
            )
            merchantData = data.data[0]
            // delete merchantData.codRemittanceConfig;
            delete merchantData.mappedOrderRule
            delete merchantData.wallet
            delete merchantData.pickup_details
            delete merchantData.bank_details
            delete merchantData.alertSubscription
            delete merchantData.gstDetails
            delete merchantData.merchantWebHooks
            delete merchantData.activeSlas
            delete merchantData.alertSubscriptionB2B
            const userInfo = {...dataLogin, merchant: merchantData}
            dispatch(login(userInfo))
            dispatch(fetchReportData(merchantOid))
          }
        } catch (e) {
          console.error(e)
          if (e.response?.status === 401) {
            enqueueSnackbar('Invalid username or password', {variant: 'error'})
          } else if (e.response.status === 403) {
            enqueueSnackbar(e.response?.data || 'Access Denied', {variant: 'error'})
          } else {
            enqueueSnackbar(e.response.data?.error || 'Login failed', {
              variant: 'error',
            })
          }
        }
      } else {
        enqueueSnackbar(res.data.error || 'Invalid OTP', {variant: 'error'})
      }
    } catch (error) {
      console.log(error)
      enqueueSnackbar(error.response?.data?.message || 'Invalid OTP', {variant: 'error'})
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Box>
      <HeaderContainer>
        <WelcomeTitle variant='h4'>Verification Code</WelcomeTitle>
        <SubTitle variant='body1' color='text.secondary'>
          We’ve sent a verification code to your mobile number.
        </SubTitle>
      </HeaderContainer>

      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <StyledTextField
              variant='outlined'
              name='otp'
              autoFocus
              placeholder='Please enter verification code'
              label='Enter OTP'
              InputProps={{
                startAdornment: (
                  <IconContainer>
                    <StyledIcon>
                      <Password />
                    </StyledIcon>
                  </IconContainer>
                ),
              }}
              size='large'
              key='otp-input'
              inputProps={{
                autoComplete: 'one-time-code',
                maxLength: 6,
                pattern: '[0-9]*',
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Stack spacing={2}>
              <StyledLoadingButton
                variant='contained'
                color='warning'
                size='medium'
                loading={isLoading}
                type='submit'
                startIcon={<VerifiedUser />}
              >
                Verify OTP
              </StyledLoadingButton>

              <StyledDivider>
                <DividerText variant='body2' color='text.secondary'>
                  OR
                </DividerText>
              </StyledDivider>
              <ForgotPasswordButton variant='text' component={Link} to='/login'>
                Back to Login
              </ForgotPasswordButton>
            </Stack>
          </Grid>
        </Grid>
      </FormProvider>
    </Box>
  )
}
